import { NEWBUILDING_MY_HOME_TRAP } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentActive } from '../../utils/experiments';

export const selectMyHomeShowTrap = (state: IApplicationState) => {
  return state.myHome.showTrap && getIsMyHomeTrapExperimentActive(state);
};

function getIsMyHomeTrapExperimentActive(state: IApplicationState) {
  const { experiments } = state;

  return isAbUseExperimentActive(experiments, NEWBUILDING_MY_HOME_TRAP, 'B');
}
